module.exports = __webpack_public_path__ + "static/img/osde-4.639c33b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/osde-4.jpg
// module id = a93w
// module chunks = 1